export default class extends HTMLElement {
  connectedCallback () {
    this.buttons = this.querySelectorAll('[data-period]')
    this.monthlyPrice = this.querySelector('[data-monthly-price]')
    this.yearlyPrice = this.querySelector('[data-yearly-price]')

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.select(button.dataset.period))
    })
  }

  select (period) {
    this.buttons.forEach((button) => {
      const active = button.dataset.period === period

      button.classList.toggle('btn-neutral', active)
      button.classList.toggle('text-white', active)
      button.classList.toggle('btn-ghost', !active)
    })

    if (period === 'yearly') {
      this.monthlyPrice?.classList.add('hidden')
      this.yearlyPrice?.classList.remove('hidden')
    } else {
      this.monthlyPrice?.classList.remove('hidden')
      this.yearlyPrice?.classList.add('hidden')
    }
  }
}
